export const  frontEndBaseUrl = window.location.origin;
// export const  frontEndBaseUrl = 'https://login.dev.pulseright.io';
